interface FlyingSparklingBirdIcon {
  className?: string
}

export const FlyingSparklingBirdIcon: React.FC<FlyingSparklingBirdIcon> = ({
  className = "",
}) => {
  return (
    <svg
      width="36"
      height="37"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M26.9441 11.7949L26.9589 11.7956"
        stroke="white"
        strokeWidth="2.16061"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.92649 27.8965L20.0145 28.4348C23.2784 28.5846 26.4682 27.4315 28.882 25.2294C31.2959 23.0273 32.7361 19.9565 32.8858 16.6926L33.0975 12.0775C33.1611 10.7669 32.8045 9.47016 32.0797 8.37634C31.3548 7.28251 30.2996 6.44874 29.0678 5.99651C27.836 5.54428 26.492 5.49722 25.2316 5.8622C23.9711 6.22718 22.8602 6.98512 22.0606 8.02558L17.1434 14.4639M5.02439 29.8799L9.91539 23.7528"
        stroke="white"
        strokeWidth="1.91397"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M31.7332 7.17773L34.4555 5.54435L32.8222 8.26666"
        stroke="white"
        strokeWidth="2.16061"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9958 29L6.73322 35.4911"
        stroke="white"
        strokeWidth="1.91397"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M17.6208 29L12.7332 35.0286"
        stroke="white"
        strokeWidth="1.91397"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M7.82226 7.08903L6.54391 11.6214L5.26561 7.08898L0.733238 5.81068L5.26557 4.53233L6.54391 0L7.82226 4.53233L12.3546 5.81068L7.82226 7.08903Z"
        fill="#FFF440"
      />
      <path
        d="M1.20365 15.7254C1.99062 17.8452 3.41163 19.6711 5.2733 20.9546C7.13497 22.238 9.34689 22.9167 11.608 22.8983C13.8692 22.8798 16.0697 22.1651 17.9102 20.8515C19.7507 19.5378 21.1417 17.689 21.894 15.5565"
        stroke="white"
        strokeWidth="1.91397"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
